(() => {
  const storageKey = 'kokoNewsletterPending';
  const successMessage = 'Thanks for subscribing to our newsletter.';
  const verificationMessage = 'Complete the security check to continue subscribing.';
  const pendingLifetime = 5 * 60 * 1000;

  function readPending() {
    try {
      const pending = JSON.parse(sessionStorage.getItem(storageKey));
      if (!pending || Date.now() - pending.startedAt > pendingLifetime) {
        sessionStorage.removeItem(storageKey);
        return null;
      }
      return pending;
    } catch {
      return null;
    }
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(storageKey);
    } catch {}
  }

  function writePending(email) {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({ email, startedAt: Date.now() }));
    } catch {}
  }

  function showStatus(form, message, state) {
    const status = form.querySelector('[data-koko-newsletter-status]');
    if (!status) return;
    status.textContent = message;
    status.dataset.state = state;
    form.setAttribute('aria-busy', state === 'pending' || state === 'verification' ? 'true' : 'false');
  }

  function hasShopifyChallenge() {
    return Boolean(document.querySelector(
      'iframe[src*="hcaptcha.com"], iframe[title*="hCaptcha"], .shopify-challenge__container'
    ));
  }

  function initForm(form) {
    const serverError = form.querySelector('[data-koko-newsletter-server-error]');
    const serverSuccess = form.querySelector('[data-koko-newsletter-server-success]');

    if (serverError) {
      clearPending();
      form.setAttribute('aria-busy', 'false');
    } else if (serverSuccess) {
      clearPending();
      showStatus(form, serverSuccess.textContent.trim() || successMessage, 'success');
    } else if (readPending()) {
      showStatus(form, verificationMessage, 'verification');
    }

    const challengeObserver = new MutationObserver(() => {
      const status = form.querySelector('[data-koko-newsletter-status]');
      if (
        readPending()
        && status?.dataset.state !== 'success'
        && status?.dataset.state !== 'verification'
        && hasShopifyChallenge()
      ) {
        showStatus(form, verificationMessage, 'verification');
      }
    });
    challengeObserver.observe(document.documentElement, { childList: true, subtree: true });

    form.addEventListener('submit', () => {
      const email = form.querySelector('input[type="email"]')?.value.trim() || '';
      writePending(email);
      showStatus(form, 'Submitting your subscription…', 'pending');
    });
  }

  function init() {
    document.querySelectorAll('[data-koko-newsletter-form]').forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
